"use client";
import React, { useState } from "react";
import "../../contents/scss/buyThisWay.scss";
import { WorkCarPath } from "../common/defaultImage/DefaultPaths";
import { GetDefaultImagePath } from "../common/defaultImage/DefaultImage";
import { SanityImage } from "@/sanity/SanityImage";
import Link from "next/link";
import { HowItWorksArrowSVG } from "../../contents/svgs/howItWorks";

function BuyThisWay({ buyThisWay }) {
    const [showVideo, setShowVideo] = useState(false);
    const handleThumbnailClick = () => {
        setShowVideo(true);
    };
    return (
        <>
            <div className="How_it_works_banner text-center">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6 px-0">
                            <div className="work-banner">
                                <div className="video-container">
                                    {showVideo ? (
                                        <video
                                            width="100%"
                                            height="100%"
                                            controls
                                            preload="none"
                                            autoPlay>
                                            <source
                                                src="https://storage.googleapis.com/tc-production-390801.appspot.com/thiscar/sell-your-car-to-thiscar-com.mp4"
                                                type="video/mp4"
                                                autoPlay="1"
                                            />
                                            Your browser does not support the video tag
                                        </video>
                                    ) : (
                                        <>
                                            <h2>How THIS Works</h2>
                                            <div
                                                onClick={handleThumbnailClick}
                                                className="thumbnail-container">
                                                <SanityImage
                                                    className=""
                                                    src={buyThisWay.image}
                                                    defaultImage={GetDefaultImagePath(WorkCarPath)}
                                                    alt=""
                                                    sizes="100vw"
                                                    style={{
                                                        width: "100%",
                                                        height: "auto"
                                                    }}
                                                    width={1000}
                                                    height={800}
                                                />
                                                <div className="play-button">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 448 512"
                                                        onClick={handleThumbnailClick}>
                                                        <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6 col-sm-12 offset-xl-1 right-side">
                            <div
                                className="left_banner
        ">
                                <div className="px-sm-0 pt-sm-5">
                                    <h2>{buyThisWay.heading}</h2>
                                    <p>{buyThisWay.subtext}</p>
                                    <Link
                                        href={"/cars"}
                                        className="nav-anchor"
                                        passHref>
                                        <button className="btn btn-sm custom_btn">
                                            Find your car
                                            <HowItWorksArrowSVG />
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BuyThisWay;
